import React from 'react'

import SymposiumSpeakerCard from "./SymposiumSpeakerCard";

import { useTranslation } from "react-i18next";
import { t } from 'i18next';


import "./SymposiumSpeakerCard.css";

import img_jong from "../../images_speaker_resize/jong_2_crop_resize.jpg";
import sangchul from '../../images_speaker/sangchul_crop.png'
import haeyung from '../../images_speaker/haeyung_crop.jpg'
import empty_img1 from '../../images_speaker/empty1.png'
import empty_img2 from '../../images_speaker/empty2.png'
import ShareIco from '../../images/share_icon.png';
import img_semin from "../../images_speaker/seminlee_crop.jpg"

const SymposiumSpeakerCards = () => {
  return (
    <div>
        <div className='sect-01-box-01-seminar'><div className="sect-03-tit-01 sect-tit">{t("seminar_speaker_title")}</div></div>
        <div className='SymposiumSpeakerCards-container'>
            <SymposiumSpeakerCard img={sangchul} date={t("schedule_date1")} time={t("seminar_schedule_date1_sem0_hours")} title={t("seminar_schedule_date1_sem2_title")} name={t("seminar_speaker_2_name")}
                affiliation={t("seminar_speaker_2_belong")} cv_1={t("seminar_speaker_2_intro1")} cv_2={t("seminar_speaker_2_intro2")} cv_3={t("seminar_speaker_2_intro3")} />
            <SymposiumSpeakerCard img={haeyung} date={t("schedule_date2")} time={t("seminar_schedule_date2_sem1_hours")} title={t("seminar_schedule_date2_sem1_title")} name={t("seminar_speaker_3_name")}
                affiliation={t("seminar_speaker_3_belong")} cv_1={t("seminar_speaker_3_intro1")} cv_2={t("seminar_speaker_3_intro2")} cv_3={t("seminar_speaker_3_intro3")} />
            <SymposiumSpeakerCard img={img_semin} date={t("schedule_date2")} time={t("seminar_schedule_date2_sem2_hours")} title={t("seminar_schedule_date2_sem2_title")} name={t("seminar_speaker_4_name")}
                affiliation={t("seminar_speaker_4_belong")} cv_1={t("seminar_speaker_4_intro1")} cv_2={t("seminar_speaker_4_intro2")} cv_3={t("seminar_speaker_4_intro3")} />
            <SymposiumSpeakerCard img={img_jong} date={t("schedule_date3")} time={t("seminar_schedule_date3_sem1_hours")} title={t("seminar_schedule_date1_sem1_title")} name={t("seminar_speaker_1_name")}
                affiliation={t("seminar_speaker_1_belong")} cv_1={t("seminar_speaker_1_intro1")} cv_2={t("seminar_speaker_1_intro2")} cv_3={t("seminar_speaker_1_intro3")} />
            {/* <SymposiumSpeakerCard img={empty_img1} date={t("schedule_date3")} time={t("seminar_schedule_date3_sem2_hours")} title={t("seminar_schedule_date3_sem1_title")} name={t("seminar_speaker_5_name")}
                affiliation={t("seminar_speaker_5_belong")} cv_1={t("seminar_speaker_5_intro1")} cv_2={t("seminar_speaker_5_intro2")} cv_3={t("seminar_speaker_5_intro3")} /> */}
        </div>
    </div>
  )
}

export default SymposiumSpeakerCards